
  import { greekSearchFilter } from "@/helpers/data";
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
  import { commonModule, actionTypesModule } from '@/store/modules/store-accessor'
  import { hexColorRemoveLastTwoDigits, isDecimalNumber, periodToText, isNumber, periodOptionToNumber, periodOptionToComboText, periodOptionToComboValue, timeChargedUnitOption, getOptimalTextColor, durationOptionByMinutes } from "@/helpers/data";
  import _ from 'lodash';

  @Component
  export default class EditActionTypeModal extends Vue {
    @Prop()
    payload!: any;

    isEditingActionType = false;

    greekSearchFilter = greekSearchFilter;

    actionTypeModel = {
        id: this.payload.actionType.id,
        text: this.payload.actionType.text,
        color: this.payload.actionType.color,
        cost: this.payload.actionType.cost,
        is_periodic: this.payload.actionType.is_periodic,
        periodic_days: this.payload.actionType.periodic_days,
        periodic_option_value: periodOptionToNumber(this.payload.actionType.periodic_option),
        periodic_option_combo: { text: periodOptionToComboText(this.payload.actionType.periodic_option), period: periodOptionToComboValue(this.payload.actionType.periodic_option) },
        reminder_days: this.payload.actionType.reminder_days,
        reminder_option_value: periodOptionToNumber(this.payload.actionType.reminder_option),
        reminder_option_combo: { text: periodOptionToComboText(this.payload.actionType.reminder_option), period: periodOptionToComboValue(this.payload.actionType.reminder_option) },
        periodic_option: '',
        reminder_option: '',
        duration: this.payload.actionType.duration,
        is_time_charged: this.payload.actionType.is_time_charged || false,
        unit: timeChargedUnitOption(this.payload.actionType.unit),
    }

    textRule = [
        (val: any) => !!val || this.$i18n.t("actionTypeRequired"),
        (val: any) => val.length <= 70 || this.$i18n.t("actionTextLengthRule"),
    ]
    costRule = [
      (val: any) => val !== '' && val >= 0 || this.$i18n.t("actionCostRuleText"),
    ]
    durationRule = [
      (val: any) => !!val || this.$i18n.t("duration_required"),
    ]

    periodRule = [
      (val: any) => val !== '' && val > 0 && val.length <= 4 || this.$i18n.t("repeatEveryRuleText"),
    ]

    reminderRule = [
      (val: any) => val !== '' && val > 0 && val.length <= 4 || this.$i18n.t("reminderRuleText"),
    ]

    periodicOptionRule = [
      (val: any) => ((!!val || val == '') && val.text.length > 0) || this.$i18n.t("periodicOptionRuleText"),
    ]

    reminderOptionRule = [
      (val: any) => ((!!val || val == '') && val.text.length > 0) || this.$i18n.t("reminderOptionRuleText"),
    ]
    unitOptionRule = [
      (val: any) => ((!!val || val == '') && val.text.length > 0) || this.$i18n.t("unitOptionRule"),
    ]

    get periodicCombo () {
      return commonModule.periodicCombo;
    }

    get timeChargedUnitCombo() {
      return commonModule.timeChargedUnitCombo;
    }

    get durationCombo() {
      return commonModule.durationCombo;
    }

    optimalTextColor(color: string) {
      return getOptimalTextColor(color);
    }

    async hideModal () {
      commonModule.hideModal();
    }

    defaultPeriodicOption() {
      if(this.periodicCombo) {
        this.actionTypeModel.periodic_option_value = '1';
        return { text: this.$i18n.t('Year'), period: 365 };
      }
    }

    defaultPeriodicReminderOption() {
      if(this.periodicCombo) {
        this.actionTypeModel.reminder_option_value = '1';
        return { text: this.$i18n.t('week'), period: 7 };
      }
      return { text: '', period: 0 };
    }

    async mounted () {
      commonModule.initSnackbar({});
      await commonModule.getPeriodicCombo(1);
      actionTypesModule.getAllActionTypes();
      await commonModule.getTimeChargedUnitCombo();
      await commonModule.getDurationCombo();
      (this.actionTypeModel.periodic_option_combo as any) = !this.actionTypeModel.periodic_option_combo.text ? this.defaultPeriodicOption() : this.actionTypeModel.periodic_option_combo;
      (this.actionTypeModel.reminder_option_combo as any) = !this.actionTypeModel.reminder_option_combo.text ? this.defaultPeriodicReminderOption() : this.actionTypeModel.reminder_option_combo;
      (this.actionTypeModel.duration as any) = durationOptionByMinutes(this.durationCombo, this.payload.actionType.duration) || this.durationCombo[1] || '';
    }

    get allActionTypes() {
      return actionTypesModule.actionTypes;
    }

    typeFound(type: any) {
      let excludeCurrentType = this.allActionTypes.filter(type => type['text'] !== this.payload.actionType.text)
      for (let i = 0; i < excludeCurrentType.length; i++) {
        if (excludeCurrentType[i]['text'] === type) {
          return true;
        }
      }
      return false;
    };

    @Watch('actionTypeModel.text')
    onTextChange(val: string, oldVal: string) {
      // Remove typeFound (duplicate) rule if it already exists from a previous check
      if (this.textRule.length > 2) {
        this.textRule.pop();
      }
      if (this.typeFound(this.actionTypeModel.text)) {
        this.textRule.push((val: any) => this.typeFound(val.text) || this.$i18n.t("actionExists"))
      }
    }

    async doUpdateActionType() {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.isEditingActionType = true;
        this.actionTypeModel.color = hexColorRemoveLastTwoDigits(this.actionTypeModel.color);

        let actionTypeModelCopy = _.cloneDeep(this.actionTypeModel);

        actionTypeModelCopy.periodic_days = (parseInt(this.actionTypeModel.periodic_option_value) * this.actionTypeModel.periodic_option_combo.period).toString()
        actionTypeModelCopy.periodic_option = this.actionTypeModel.periodic_option_value + periodToText(this.actionTypeModel.periodic_option_combo.period)
        actionTypeModelCopy.reminder_days = (parseInt(this.actionTypeModel.reminder_option_value) * this.actionTypeModel.reminder_option_combo.period).toString()
        actionTypeModelCopy.reminder_option = this.actionTypeModel.reminder_option_value + periodToText(this.actionTypeModel.reminder_option_combo.period)

        await actionTypesModule.editActionType(actionTypeModelCopy);
        await actionTypesModule.getAllActionTypes();
        this.hideModal();
      }
    }
    onlyDecimalNumbers(evt: any) {
      isDecimalNumber(evt);
    }
    onlyNumbers(evt: any) {
      isNumber(evt);
    }
  };
